import { GiftCardPreviewInfo } from "../../../models/api/ordersApiTypes"
import useCheckMobileResolution from "../../../hook/useCheckMobileResolution"
import "./style.css"

interface GiftCardPreviewProps {
  giftCard: GiftCardPreviewInfo
  index: number
  expanded: boolean
  onToggle: () => void
  handleRemoveGiftCard: (index: number) => void
  handleCopyGiftCard: (index: number) => void
  handleShowEditGiftCardModal: (index: number, EditdGiftCard: GiftCardPreviewInfo) => void
}

export default function GiftCardPreview({
  giftCard,
  index,
  expanded,
  onToggle,
  handleRemoveGiftCard,
  handleCopyGiftCard,
  handleShowEditGiftCardModal,
}: GiftCardPreviewProps) {
  const isMobile = useCheckMobileResolution()
  const priceMultiplier = 100

  const toggleExpanded = () => onToggle()

  const actions = (
    <div className="gift-card-preview-actions">
      <img
        src={`${process.env.PUBLIC_URL}/img/edit-icon.svg`}
        alt="Modifica"
        title="Modifica"
        className="gift-card-preview-action-icon"
        onClick={() => handleShowEditGiftCardModal(index, giftCard)}
      />
      <img
        src={`${process.env.PUBLIC_URL}/img/copy-icon.svg`}
        alt="Duplica"
        title="Duplica"
        className="gift-card-preview-action-icon"
        onClick={() => handleCopyGiftCard(index)}
      />
      <img
        src={`${process.env.PUBLIC_URL}/img/delete-icon.svg`}
        alt="Elimina"
        title="Elimina"
        className="gift-card-preview-action-icon"
        onClick={() => handleRemoveGiftCard(index)}
      />
    </div>
  )

  return (
    <div className="gift-card-preview-container">
      <div className="gift-card-preview-header">
        <button
          type="button"
          className="gift-card-preview-toggle"
          onClick={toggleExpanded}
          aria-expanded={expanded}
          title={expanded ? "Comprimi" : "Espandi"}
        >
          <span className={`gift-card-preview-chevron ${expanded ? "expanded" : ""}`}>›</span>
        </button>

        <div className="gift-card-preview-summary" onClick={toggleExpanded}>
          <span className="gift-card-preview-summary-name">{giftCard.recipientName || "Destinatario"}</span>
          {giftCard.recipientEmail && (
            <>
              <span className="gift-card-preview-summary-sep">·</span>
              <span className="gift-card-preview-summary-email">{giftCard.recipientEmail}</span>
            </>
          )}
          <span className="gift-card-preview-summary-sep">·</span>
          <span className="gift-card-preview-summary-price">{giftCard.price / priceMultiplier}€</span>
        </div>

        {actions}
      </div>

      {expanded && (
        <div
          className="gift-card-preview-details"
          style={isMobile ? { flexDirection: "column", alignItems: "center" } : { flexDirection: "row" }}
        >
          <img
            style={isMobile ? { width: "120px", marginBottom: "10px" } : { width: "120px" }}
            src={giftCard.graphicUrl}
            alt="Grafica selezionata"
          />
          <div className="gift-card-preview-info" style={{ marginLeft: isMobile ? 0 : "20px" }}>
            <div className="gift-card-preview-info-line">
              Nome destinatario: <i>{giftCard.recipientName}</i>
            </div>
            <div className="gift-card-preview-info-line">
              Email destinatario: <i>{giftCard.recipientEmail || "Invio all'email del mittente"}</i>
            </div>
            <div className="gift-card-preview-info-line gift-card-message">
              Messaggio:{" "}
              <i>{giftCard.message.length > 30 ? `${giftCard.message.substring(0, 30)}...` : giftCard.message}</i>
            </div>
            <div style={{ marginTop: "auto", fontWeight: "600" }}>{giftCard.price / priceMultiplier}€</div>
          </div>
        </div>
      )}
    </div>
  )
}
